import styles from "./BulletPoint.module.css";

interface BulletPointProps {
  text: string;
  className?: string;
}

function BulletPoint(props: BulletPointProps) {
  if (!props.text) {
    return null;
  }
  return (
    <div className={`${styles.line} ${props.className ?? ""}`}>
      <div className={styles.checkIcon}>
        <span className="narmi-icon-check" />
      </div>
      <span>{props.text}</span>
    </div>
  );
}

export { BulletPoint };
